import $ from 'jquery';
import {toggleAttribute} from "../../js/utils/helpers";

const ATTR_ARIA_EXPANDED = 'aria-expanded';
const ARIA_EXPANDED_TRUE = 'true';
const ARIA_EXPANDED_FALSE = 'false';

export default class FilterList {

  constructor(el) {

    this.filterList = el;
    this.allActiveBtn = el.find('.js-filter-list-btn-all');
    this.filterBtn = el.find('.js-filter-list-btn');
    this.filterCard = el.find('.js-filter-list-card');
    this.showMoreLink = el.find('.js-filter-list-more');
    this.numOfActive = 0;
    this.CARDS_BY_STEP = 5;
    this.hiddenCardIndex = this.CARDS_BY_STEP;
    this.visibleFilter = null;
    this.lastActiveFilterBtn = null;
    this.lastActiveCategory = null;

    //this.setCategories(this.filterBtn);
    var categories = this.getCategories(this.filterBtn);
    //this.applyRandCategories(this.filterCard);
    this.categoryMap = this.buildCategoryMap(categories);
    this.setNumOfElementsByCategory(this.categoryMap);

    this.handleEvents();
  
    if (this.allActiveBtn.hasClass("is-active")) {
      this.lastActiveFilterBtn = this.allActiveBtn;
    }

    if (this.isMobile()) {
      this.handleMaxOfCardsShown(true);
    }
  }

  isMobile() {
    return $(window).width() <= 768;
  }

  buildCategoryMap(categories) {
    var categoryMap = {};

    categories.forEach(categoryName => {
      categoryMap[categoryName] = {
        elements: this.getElementsOfCategory(categoryName),
        active: false
      }
    });

    return categoryMap;
  }

  setNumOfElementsByCategory(categoryMap) {
    var total = 0;
    for (var category in categoryMap) {
      let len = categoryMap[category].elements.length;
      total += len;

      if (len === 0) {
        this.filterBtn
          .filter('[data-category='+category+']')
          .css('display', 'none');
      } else {
        this.filterBtn.filter('[data-category='+category+']')
          .find('span')
          .html(
            '('+ len +')'
          );
      }
    }

    this.allActiveBtn.find('span').html(
      '('+ this.filterCard.length + ')'
    );
  }

  getElementsOfCategory(categoryName) {
    let cards = this.filterList.find('.js-filter-list-card'),
        categoryCards = [];

    cards.each( (i, card) => {
      var regexp = new RegExp(categoryName + "(?=\\s+|$)");

      if (regexp.test($(card).attr('data-category'))) {
        categoryCards.push(card);
      }
    });

    return categoryCards;
  }

  handleEvents() {
    let self = this;

    if ($(window).width() >= 768) {
      this.filterBtn.click(
        this.filterCards(self)
      );
    } else {
      this.filterBtn.click(
        this.filterMobileCards(self)
      );

      this.showMoreLink.click(
        this.showMoreCards(self)
      );

      this.handleMaxOfCardsShown();
    }

    this.allActiveBtn.click(
      this.handleAllActiveBtn(self)
    );
  }

  handleAllActiveBtn(self) {
    return function () {
      $(this).addClass('is-active');
      $(this).attr(ATTR_ARIA_EXPANDED, ARIA_EXPANDED_TRUE);
      self.unsetActiveCategory();
      self.setAllActiveFilter();
      self.resetHiddenIndex();
      self.handleMaxOfCardsShown(true);
      self.lastActiveFilterBtn = self.allActiveBtn;
      self.lastActiveCategory = null;
    };
  }

  filterCards(self) {
    return function () {
      self.toggleActiveState($(this));
      self.toggleCategory($(this).attr('data-category'));
    }
  }

  filterMobileCards(self) {
    return function () {
      self.toggleActiveState($(this));
      self.toggleCategory($(this).attr('data-category'));
      self.handleMaxOfCardsShown();
    }    
  }

  toggleActiveState(filterBtn) {
    if (this.lastActiveFilterBtn) {
      this.lastActiveFilterBtn.attr(ATTR_ARIA_EXPANDED, ARIA_EXPANDED_FALSE);
      this.lastActiveFilterBtn.removeClass('is-active');
      if (this.lastActiveFilterBtn === this.allActiveBtn) {
        this.filterList.removeClass('all-visible');
      }
    }
    filterBtn.attr(ATTR_ARIA_EXPANDED, ARIA_EXPANDED_TRUE);
    filterBtn.toggleClass('is-active');
    this.lastActiveFilterBtn = filterBtn;
  }

  toggleCategory(categoryName) {
    if (this.allActiveBtn.hasClass('is-active')) {
      this.unsetAllActiveFilter();
    }

    this.resetHiddenIndex();
    this.hideCardsOfLastActiveCategory();
    this.showCardsOfCategory(categoryName);
    this.lastActiveCategory = categoryName;
  }

  showCardsOfCategory(categoryName) {
      this.categoryMap[categoryName].elements.sort(function(a, b) {
          var categoryIndex = categoryName.replace('category-','');

          var indexA = a.dataset["category_order_" + categoryIndex];
          var indexB = b.dataset["category_order_" + categoryIndex]
          return indexB - indexA;
      });

    this.categoryMap[categoryName].elements.forEach(filterCard => {
      $(filterCard).prependTo('.js-filter-list .dcw_grid');
      $(filterCard).addClass('is-visible');
    });
  }

  hideCardsOfLastActiveCategory() {
    return this.lastActiveCategory &&
    this.categoryMap[this.lastActiveCategory].elements.forEach(filterCard => {
      $(filterCard).removeClass('is-visible');
    });
  }

  handleMaxOfCardsShown(isAllFilter) {
    let cardsVisible = isAllFilter ?
      this.filterCard :
      this.filterCard.filter('.is-visible');

    if (this.hasMoreThanMaxOfCards(cardsVisible)) {
      this.showShowMoreLink();
      this.hideRemainingCards(cardsVisible);
    } else {
      this.resetHiddenIndex();
      this.hideShowMoreLink();
    }
  }

  hasMoreThanMaxOfCards(cardsVisible) {
    return (cardsVisible.length - this.hiddenCardIndex) > 0;
  }

  allCardsShownForCategory() {
    if (this.lastActiveCategory) {
      return this.categoryMap[this.lastActiveCategory].elements.length === this.hiddenCardIndex;
    }

    return this.filterCard.length === this.hiddenCardIndex;
  }

  hideRemainingCards(cards) {
    $(cards).eq(this.hiddenCardIndex -1)
      .addClass('is-last-visible');
  }

  showMoreCards(self) {
    return function (e) {
      e.preventDefault();

      let cardsVisible = self.filterCard.filter('.is-visible').length === 0 ? self.filterCard : self.filterCard.filter('.is-visible'),
          hiddenCardIndex = self.hiddenCardIndex + Math.min(self.CARDS_BY_STEP, cardsVisible.length - self.hiddenCardIndex);

      cardsVisible.eq(self.hiddenCardIndex - 1).removeClass('is-last-visible');
      cardsVisible.eq(hiddenCardIndex - 1).addClass('is-last-visible');

      self.hiddenCardIndex = hiddenCardIndex;

      if (self.allCardsShownForCategory()) {
        self.hideShowMoreLink();
      }
    }
  }


  resetHiddenIndex() {
    this.filterCard.filter('.is-last-visible')
      .removeClass('is-last-visible');
    this.hiddenCardIndex = this.CARDS_BY_STEP;
  }

  showShowMoreLink() {
    this.showMoreLink.removeClass('is-hidden');
  }

  hideShowMoreLink() {
    this.showMoreLink.addClass('is-hidden');
  }

  updateNumOfActive(isActive) {
    return isActive ?
      ++this.numOfActive :
      --this.numOfActive;
  }

  getCategories() {
    return [].map.call(this.filterBtn, btn => (
      $(btn).attr('data-category')
    ));
  };

  setAllActiveFilter() {
    this.allActiveBtn.addClass('is-active');
    this.filterList.addClass('all-visible');
  }

  unsetAllActiveFilter() {
    this.allActiveBtn.removeClass('is-active');
    this.filterList.removeClass('all-visible');
  }

  unsetActiveCategory() {
    this.filterBtn
      .filter('.is-active')
      .attr(ATTR_ARIA_EXPANDED, ARIA_EXPANDED_FALSE)
      .removeClass('is-active');

    this.categoryMap[this.lastActiveCategory]
        .elements.forEach(categoryElement => {
      $(categoryElement).removeClass('is-visible');
    });
  }
}


// WEBPACK FOOTER //
// ./src/components/filter-list/filter-list.js